import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { RootReducer } from "../reducers/RootReducer";

const RootContext = createContext({
	state: RootReducer.getInitialState(),
	actions: RootReducer.actions,
});

export const useRootContext = () => useContext(RootContext);

export const RootProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: RootReducer.getInitialState(),
		reducers: RootReducer.caseReducers,
	});
	return (
		<RootContext.Provider value={{ state, actions }}>
			{children}
		</RootContext.Provider>
	);
};
